import React from 'react';
import styles from './styles/SituationsList.module.css';
import { useCanvas } from '../../../context/CanvasContext';
import { useEditorUI } from '../../../context/EditorUIContext';

/**
 * The situations belonging to a group.
 *
 * Membership lives on the situation (`node.data.situationGroup`), never on the
 * group — `SituationGroup.situations` is rebuilt from the draft at publish time.
 * So removing one from a group is a single field edit on the node.
 *
 * @param {{nodes: Array}} props - The member nodes, already filtered by the caller.
 */
const SituationsList = ({ nodes = [] }) => {
    const { updateSituation } = useCanvas();
    const { selectItem, setActiveEditTab } = useEditorUI();

    const handleSituationClick = (nodeId) => {
        selectItem('situation', nodeId);
        setActiveEditTab('1');
    };

    if (nodes.length === 0) {
        return (
            <div className={styles.situationsContainer}>
                <div className={styles.noSituationsText}>No Situations</div>
            </div>
        );
    }

    return (
        <div className={styles.situationsContainer}>
            {nodes.map((node) => (
                <div
                    key={node.id}
                    className={styles.situationItem}
                    onClick={() => handleSituationClick(node.id)}
                >
                    <div className={styles.situationTitle}>{node.data?.title || 'Untitled'}</div>
                    <button
                        className={styles.removeButton}
                        onClick={(event) => {
                            event.stopPropagation();
                            updateSituation(node.id, { situationGroup: null });
                        }}
                        aria-label="Remove situation"
                    >
                        <span className={styles.minusIcon}>−</span>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default SituationsList;
